import { enumOptionsToObject } from '../../internal'

export const MarketingIconOptions = [
  'ComfortRoad',
  'Cargo',
  'Trail',
  'RockyTerrain',
  'OpenAir',
  'Handlebars',
  'Stylish',
  'SnowTrail',
  'ComfortSnow',
  'ComfortPon',
  'Luxury',
  'Agile',
  'Mountain2',
  'ActiveRiding',
  'Comfort',
  'Heat',
  'MultiTerrain',
  'Steady',
  'ComfortPon2',
  'Trail2',
  'Strong',
  'Agility',
  'Bagger',
  'Cruiser',
  'FTR',
  'Touring',
  'Sporty'
] as const
export const MarketingIcons = enumOptionsToObject(MarketingIconOptions)
export type MarketingIcons = (typeof MarketingIconOptions)[number]
